import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { SNSType } from '../../../../services/firebase/firebaseAuth';
import { AppState } from '../../../../store/store';
import { AuthState, useAuth } from '../../../auth/AuthProvider';
import { showLoginModal } from '../../login.slice';
import { checkMobileBrowser } from '../../../../common/utils/utils';

import './LoginModal.scss';

export const LoginModal = (): ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isShow = useSelector((state: AppState) => state.loginModalVisibility);
  const { logInWithSNS, logInWithEveryId, logInWithLINE } =
    useAuth() as AuthState;

  const close = () => {
    dispatch(showLoginModal(false));
  };

  const signInSNS = (type: SNSType) => {
    if (checkMobileBrowser()) {
      return;
    }
    dispatch(showLoginModal(false));
    logInWithSNS(type);
  };

  const signInWithEveryId = async () => {
    if (checkMobileBrowser()) {
      return;
    }
    dispatch(showLoginModal(false));
    logInWithEveryId();
  };

  const signInWithLINE = async () => {
    if (checkMobileBrowser()) {
      return;
    }
    dispatch(showLoginModal(false));
    logInWithLINE();
  };

  if (!isShow) {
    return <></>;
  }

  return (
    <div className="login-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content login-modal__content">
          {/* Header */}
          <div className="login-modal__close-btn" onClick={close}>
            <AiOutlineClose />
          </div>
          <h2 className="login-modal__title">{t('Login')}</h2>

          {/* Log in with SNS */}
          <div className="login-modal__label">{t('WithSNS')}</div>

          {/* Google */}
          <button
            className="login-modal__sns-btn--google"
            onClick={() => {
              signInSNS(SNSType.GOOGLE);
            }}
          >
            Google
          </button>

          {/* Facebook */}
          <button
            className="login-modal__sns-btn--facebook"
            onClick={() => {
              signInSNS(SNSType.FACEBOOK);
            }}
          >
            Facebook
          </button>

          {/* Twitter */}
          <button
            className="login-modal__sns-btn--twitter"
            onClick={() => {
              signInSNS(SNSType.TWITTER);
            }}
          >
            Twitter
          </button>

          {/* Line */}
          <button
            className="login-modal__sns-btn--line"
            onClick={() => {
              signInWithLINE();
            }}
          >
            LINE
          </button>

          {/* Apple */}
          <button
            className="login-modal__sns-btn--apple"
            onClick={() => {
              signInSNS(SNSType.APPLE);
            }}
          >
            {t('SignInWithApple')}
          </button>

          {/* Log in with EVERY ID */}
          <div className="login-modal__label">{t('Or')}</div>
          <button
            className="login-modal__sns-btn--every"
            onClick={() => {
              signInWithEveryId();
            }}
          >
            EVERY ID
          </button>

          {/* Term of use */}
          <span className="login-modal_term">
            everyliveへの登録は
            <a
              target={'_blank'}
              href="https://everylive.jp/assets/terms/service_terms.pdf"
              rel="noreferrer"
            >
              利用規約
            </a>
            に同意したものとみなします
          </span>
        </div>
      </div>
    </div>
  );
};
